/**
 * This file is created manually
 * You can change the content
 *
 */

import Dd from './lists/Dd'
export * from './lists/Dd'
export default Dd
